export default `
  subscription OnUpdateCardComment($workflowId: String) {
    onUpdateCardComment(workflowId: $workflowId) {
      cardId
      workflowId
      id
      text
      dateUpdated
    }
  }
`
